export default {
  startsWith: 'Commence par',
  contains: 'Contient',
  notContains: 'Ne contient pas',
  endsWith: 'Se termine par',
  equals: 'Égal à',
  notEquals: 'Différent de',
  noFilter: 'Pas de filtre',
  lt: 'Inférieur à',
  lte: 'Inférieur ou égal à',
  gt: 'Supérieur à',
  gte: 'Supérieur ou égal à',
  dateIs: 'Date est',
  dateIsNot: 'Date n\'est pas',
  dateBefore: 'Date avant',
  dateAfter: 'Date après',
  clear: 'Effacer',
  apply: 'Appliquer',
  matchAll: 'Correspondre à tout',
  matchAny: 'Correspondre à n\'importe quel',
  addRule: 'Ajouter une règle',
  removeRule: 'Supprimer la règle',
  accept: 'Oui',
  reject: 'Non',
  choose: 'Choisir',
  upload: 'Télécharger',
  cancel: 'Annuler',
  dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
  today: 'Aujourd\'hui',
  weekHeader: 'Sem',
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weak: 'Faible',
  medium: 'Moyen',
  strong: 'Fort',
  passwordPrompt: 'Entrez un mot de passe',
  emptyFilterMessage: 'Aucun résultat trouvé',
  emptyMessage: 'Aucune option disponible',
  aria: {
    trueLabel: 'Vrai',
    falseLabel: 'Faux',
    nullLabel: 'Non sélectionné',
    star: '1 étoile',
    stars: '{star} étoiles',
    selectAll: 'Tous les éléments sélectionnés',
    unselectAll: 'Tous les éléments désélectionnés',
    close: 'Fermer',
    previous: 'Précédent',
    next: 'Suivant',
    navigation: 'Navigation',
    scrollTop: 'Défiler vers le haut',
    moveTop: 'Déplacer en haut',
    moveUp: 'Déplacer vers le haut',
    moveDown: 'Déplacer vers le bas',
    moveBottom: 'Déplacer en bas',
    moveToTarget: 'Déplacer vers la cible',
    moveToSource: 'Déplacer vers la source',
    moveAllToTarget: 'Déplacer tout vers la cible',
    moveAllToSource: 'Déplacer tout vers la source',
    pageLabel: 'Page {page}',
    firstPageLabel: 'Première page',
    lastPageLabel: 'Dernière page',
    nextPageLabel: 'Page suivante',
    previousPageLabel: 'Page précédente',
    rowsPerPageLabel: 'Lignes par page',
    jumpToPageDropdownLabel: 'Aller à la page',
    jumpToPageInputLabel: 'Aller à la page',
    selectRow: 'Ligne sélectionnée',
    unselectRow: 'Ligne non sélectionnée',
    expandRow: 'Ligne développée',
    collapseRow: 'Ligne réduite',
    showFilterMenu: 'Afficher le menu de filtrage',
    hideFilterMenu: 'Masquer le menu de filtrage',
    filterOperator: 'Opérateur de filtrage',
    filterConstraint: 'Contrainte de filtrage',
    editRow: 'Modifier la ligne',
    saveEdit: 'Sauvegarder la modification',
    cancelEdit: 'Annuler la modification',
    listView: 'Vue en liste',
    gridView: 'Vue en grille',
    slide: 'Diapositive',
    slideNumber: '{slideNumber}',
    zoomImage: 'Zoomer l\'image',
    zoomIn: 'Zoomer',
    zoomOut: 'Dézoomer',
    rotateRight: 'Tourner vers la droite',
    rotateLeft: 'Tourner vers la gauche'
  }
}; 